import React, { forwardRef } from 'react';
import classNames from 'classnames';
const IconWrapper = forwardRef((props, ref) => {
    const { className, style, children, prefixCls } = props;
    const iconWrapperCls = classNames(`${prefixCls}-icon`, className);
    return (React.createElement("span", { ref: ref, className: iconWrapperCls, style: style }, children));
});
export default IconWrapper;
